import styled from 'styled-components'

export const GraphicWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 600px;
  top: 20%;
  left: 0;
  z-index: 0;

  svg {
    width: 100%;
    height: 100%;
  }

  @media (max-width: 1200px) {
    height: 440px;
    top: 38%;
  }

  @media (max-width: 900px) {
    height: 300px;
    top: 58%;
  }

  @media (max-width: 768px) {
    height: 240px;
    top: 53%;
    overflow: hidden;

    svg {
      width: 130%;
    }
  }
`
